import { generateDataTestId } from '@/lib/tests';
import type { WithChildren } from '@/lib/types';

import { Carousel, CarouselItem } from './components';
import type { Gallery } from './context';
import { CompoundProvider } from './context';

import * as S from './ImageCarousel.styles';

interface ImageCarouselProps extends WithChildren {
  gallery?: Gallery;
  isProcessing: boolean;
}

export const ImageCarousel = ({
  children,
  gallery,
  isProcessing,
}: ImageCarouselProps) => (
  <CompoundProvider value={{ gallery, isProcessing }}>
    {/*//TODO 实现 isProcessing 不加载图片*/}
    <S.Wrapper {...generateDataTestId('carousel', 'wrapper')}>
      {children}
    </S.Wrapper>
  </CompoundProvider>
);

ImageCarousel.Carousel = Carousel;
ImageCarousel.CarouselItem = CarouselItem;

ImageCarousel.displayName = 'ImageCarousel';
